import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// ── Session token storage ──────────────────────────────────────
const SESSION_KEY = "tido_session_token";

export const getSessionToken = () => localStorage.getItem(SESSION_KEY);
export const setSessionToken = (token) => {
  if (token) localStorage.setItem(SESSION_KEY, token);
  else localStorage.removeItem(SESSION_KEY);
};
export const clearSessionToken = () => localStorage.removeItem(SESSION_KEY);

export const api = axios.create({ baseURL: API });

// Attach Bearer token to every request
api.interceptors.request.use((config) => {
  const token = getSessionToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Global 401 handler — clear session and reload to trigger SSO gate
let unauthorizedHandler = null;
export const setUnauthorizedHandler = (fn) => { unauthorizedHandler = fn; };
api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    if (err.response?.status === 401) {
      clearSessionToken();
      if (unauthorizedHandler) unauthorizedHandler();
    }
    return Promise.reject(err);
  },
);

/** Trigger a file download via fetch + blob (works reliably cross-origin, ignores popup blockers). */
export async function downloadFile(url, filename) {
  const resp = await api.get(url, { responseType: "blob" });
  const blobUrl = window.URL.createObjectURL(new Blob([resp.data]));
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
}

export const WEEKDAYS_SK = ["Pondelok", "Utorok", "Streda", "Štvrtok", "Piatok", "Sobota", "Nedeľa"];
export const WEEKDAYS_SK_SHORT = ["Po", "Ut", "St", "Št", "Pi", "So", "Ne"];

export const fmtEur = (v) =>
  new Intl.NumberFormat("sk-SK", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(v || 0);
export const fmtNum = (v, digits = 1) =>
  new Intl.NumberFormat("sk-SK", { maximumFractionDigits: digits }).format(v || 0);
export const fmtPct = (v, digits = 0) =>
  `${new Intl.NumberFormat("sk-SK", { maximumFractionDigits: digits }).format(v || 0)} %`;

export const COLORS = {
  brand: "#2B4C38",
  brandHover: "#1E3627",
  bg: "#F6F7F6",
  surface: "#FFFFFF",
  textPrimary: "#1A1F1C",
  textSecondary: "#5E6962",
  textMuted: "#8A968E",
  border: "#E4E8E5",
  success: "#3E7B52",
  successBg: "#EBF4EE",
  warning: "#C78220",
  warningBg: "#FDF3E1",
  critical: "#BA3F2B",
  criticalBg: "#FBEAE7",
  neutralBg: "#EEF1EF",
};
